module.exports = __webpack_public_path__ + "img/南方医院.79e16f8a.png";